export const shellyConfig = {
  common: {
    saving: "Zapisywanie...",
    online: "Online",
    offline: "Offline",
  },

  step1: {
    title: "Konfiguracja Shelly",
    subtitle:
      "Połącz swoje konto Shelly Cloud, aby sterować przekaźnikami (zamki elektryczne, bramy itp.).",
    connected: "Konto połączone",
    notConnected: "Nie połączono",
    credentialsInfo:
      "Dane dostępowe znajdą Państwo w aplikacji Shelly: <b>User settings → Cloud authorization key</b>. Tam widoczne jest <b>Server URI</b> i można wygenerować swój <b>Auth Key</b>.",
    serverUriPlaceholder: "np. shelly-103-eu.shelly.cloud",
    serverUriHelp: "Serwer chmurowy przypisany do Państwa konta Shelly.",
    authKeyPlaceholderSaved: "•••••••• (już zapisany, zmiana opcjonalna)",
    authKeyPlaceholderNew: "Wklej swój klucz autoryzacji chmury",
    authKeyHelpSaved: "Można pozostawić puste, jeśli klucz jest już zapisany.",
    authKeyHelpNew:
      "Ten klucz umożliwia sterowanie urządzeniami: prosimy go chronić.",
    testing: "Testowanie...",
    testConnection: "Testuj połączenie",
    saveCredentials: "Zapisz dane dostępowe",
  },

  step2: {
    title: "Wybór urządzeń dla tego obiektu",
    subtitle:
      "Wybierz tylko te przekaźniki Shelly, które dotyczą <b>tego obiektu</b>. Następnie w PMS będą widoczne wyłącznie wybrane.",
    selectedCount: "wybrano: {count}",
    hintCredentials:
      "Wpisz swój Server URI oraz Auth Key i kliknij <b>Testuj połączenie</b>, aby wczytać urządzenia.",
    noDevices: "Nie znaleziono urządzeń na Państwa koncie Shelly.",
    selectPlaceholder: "Wybierz urządzenia…",
    devicesSelected: "wybrane urządzenia: {count}",
    noneSelected: "Nie wybrano urządzeń",
    channels: "kanały: {count}",
    saveDevices: "Zapisz urządzenia dla tego obiektu",
  },

  step3: {
    title: "Sterowanie i przypisanie (PMS)",
    subtitle:
      "Przypisz każdy przekaźnik do <b>drzwi głównych</b>, <b>jednostki</b> lub <b>bramy</b> i ustaw impuls otwarcia.",
    assignedCount: "przypisano: {count}",
    noSavedDevices:
      "Nie ma jeszcze zapisanych urządzeń dla tego obiektu. Skorzystaj z <b>wyboru urządzeń</b> powyżej, a następnie zapisz.",
    pulseInfo:
      "<b>Otwórz</b> wysyła impuls do przekaźnika (włącza się i sam wyłącza po ustawionej liczbie sekund): idealne do zamków elektrycznych i bram. Shelly nie generuje kodów PIN.",
    open: "Otwórz",
    openTooltip: "Otwórz (impuls)",
    turnOnTooltip: "Włącz przekaźnik",
    turnOffTooltip: "Wyłącz przekaźnik",
    refreshTooltip: "Odśwież status",
    assignment: "Przypisanie",
    assignNone: "Nieprzypisany",
    assignCommon: "Drzwi główne (wspólne)",
    assignUnit: "Drzwi apartamentu",
    assignGate: "Brama / garaż",
    hintNone: "Nie będzie sterowany z PMS.",
    hintAssigned: "Zostanie powiązany z tym obiektem na potrzeby zdalnego otwierania.",
    unitLabel: "Jednostka / obiekt",
    selectUnit: "Wybierz jednostkę",
    unitFallback: "Jednostka {id}",
    selectUnitHint: "Wybierz, którą jednostkę otwiera ten przekaźnik.",
    channelLabel: "Kanał przekaźnika",
    channelOption: "Kanał {n}",
    channelHint: "Kanał podłączony do zamka (urządzenia wieloprzekaźnikowe).",
    pulseLabel: "Impuls otwarcia (sekundy)",
    pulseHint: "Jak długo przekaźnik pozostaje włączony przy otwieraniu.",
    nameLabel: "Nazwa (opcjonalnie)",
    namePlaceholder: "np. Drzwi główne / Apt. 101",
    nameHint: "Nazwa wyświetlana w PMS dla tego urządzenia.",
    saveAssignment: "Zapisz przypisanie",
    tip:
      "Wskazówka: przypisz każdy przekaźnik i kliknij <b>Zapisz przypisanie</b>. Przyciski sterowania włączą się po przypisaniu urządzenia.",
  },

  toast: {
    loadDevicesFailed: "Nie udało się wczytać urządzeń",
    loadDevicesError: "Błąd wczytywania urządzeń",
    missingCredentials: "Należy wpisać Server URI oraz Auth Key konta Shelly.",
    connectionSuccess:
      "Połączenie udane. Znalezione urządzenia: {count}.",
    testError: "Błąd testowania połączenia",
    invalidAuthKey: "Należy wpisać prawidłowy Auth Key (co najmniej 10 znaków).",
    missingServerUri: "Należy wpisać Server URI konta Shelly.",
    credentialsSaved: "Dane dostępowe zapisane pomyślnie",
    credentialsError: "Błąd zapisywania danych dostępowych",
    credentialsSaveError: "Błąd zapisywania danych dostępowych: {error}",
    selectAtLeastOne:
      "Należy wybrać co najmniej jedno urządzenie dla tego obiektu.",
    devicesSaved: "Urządzenia zapisane dla tego obiektu",
    devicesSaveFailed: "Nie udało się zapisać urządzeń",
    saveError: "Błąd zapisywania: {error}",
    selectUnitForApartment:
      "Wybierz jednostkę dla przekaźników przypisanych jako 'Drzwi apartamentu'.",
    assignmentFailed: "Nie udało się zapisać przypisania",
    assignmentSaved: "Przypisanie zapisane pomyślnie",
    assignmentSaveError: "Błąd zapisywania przypisania: {error}",
    opOpen: "Wysłano otwarcie (impuls przekaźnika)",
    opOn: "Przekaźnik włączony",
    opOff: "Przekaźnik wyłączony",
    opDone: "Akcja wykonana",
    opFailed: "Nie udało się wykonać akcji",
    opError: "Błąd podczas wykonywania akcji",
  },
};
